import { IEvent } from '../interfaces/event';

const { REACT_APP_CLIENT_ENV } = process.env;

const sortSEPEvents = (events: IEvent[]) => {
  if (events.length <= 1) return events;

  const filteredEvents = [...events];

  const sepAssessmentIndex = filteredEvents.findIndex((x) =>
    x.eventTags?.includes('SEP Assessment'),
  );

  if (sepAssessmentIndex > -1) {
    const event = filteredEvents[sepAssessmentIndex];

    filteredEvents.splice(sepAssessmentIndex, 1);
    filteredEvents.unshift(event);

    return filteredEvents;
  }

  return events;
};

export const clientSpecificEventCarouselTransform = (events: IEvent[]) => {
  switch (REACT_APP_CLIENT_ENV) {
    case 'EK':
      return sortSEPEvents(events);
    default:
      return events;
  }
};
